const globalState = {
    isMainAppLoaded: false,
    scroll: false,
    scrollTo:'nav',
    sections_position: {},
    observedElements: [],
    rootAddress: 'https://carlosjf.dev/',
}
export default globalState